import { FC, RefObject, useState, useEffect } from 'react';

import { Enter } from '@hh.ru/magritte-common-keyboard/keys';
import { NumberInput } from '@hh.ru/magritte-ui';

import { useSelector } from 'src/hooks/useSelector';
import { ClusterKey, Range } from 'src/types/search/common/clusters';

export interface InputProps {
    name: typeof ClusterKey.Salary | typeof ClusterKey.Age;
    value: string;
    scope: Range;
    label: string;
    onSubmit: (value: string, scope: Range) => void;
    inputRef?: RefObject<HTMLInputElement>;
}

const Input: FC<InputProps> = ({ name, value, scope, label, onSubmit, inputRef }) => {
    const showSearchPreference = useSelector((state) => state.searchPreference.isShown);

    const [userInput, setUserInput] = useState(value);
    useEffect(() => setUserInput(value), [value]);

    const key = scope ? `${name}_${scope}` : name;

    return (
        <NumberInput
            name={name}
            value={userInput}
            placeholder={label}
            ref={inputRef}
            onChange={setUserInput}
            onBlur={() => onSubmit(userInput, scope)}
            onKeyDown={(event) => event.code === Enter.code && onSubmit(userInput, scope)}
            key={`novafilters-chart-input-${key}-${String(showSearchPreference)}`}
            data-qa={`novafilters-${key}`}
        />
    );
};

export default Input;
